module.exports = __webpack_public_path__ + "img/TaxVSInflation.e854004e.png";